/**
 * @generated SignedSource<<995e4c77084a818b293779684e92e203>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassesAssignmentDropdownQuery$variables = Record<PropertyKey, never>;
export type ClassesAssignmentDropdownQuery$data = {
  readonly classes: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly owner: {
        readonly lastName: string | null | undefined;
      } | null | undefined;
      readonly section: string | null | undefined;
      readonly site: {
        readonly id: string;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type ClassesAssignmentDropdownQuery = {
  response: ClassesAssignmentDropdownQuery$data;
  variables: ClassesAssignmentDropdownQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "site",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesAssignmentDropdownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ClassNodeConnection",
        "kind": "LinkedField",
        "name": "classes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "classes(first:1000)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClassesAssignmentDropdownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ClassNodeConnection",
        "kind": "LinkedField",
        "name": "classes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "classes(first:1000)"
      }
    ]
  },
  "params": {
    "cacheID": "4475477c97ae3d7ec38b36ec52b5c8bb",
    "id": null,
    "metadata": {},
    "name": "ClassesAssignmentDropdownQuery",
    "operationKind": "query",
    "text": "query ClassesAssignmentDropdownQuery {\n  classes(first: 1000) {\n    nodes {\n      id\n      name\n      section\n      site {\n        id\n      }\n      owner {\n        lastName\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c87b109943f68f42b9577b2c782e2e1e";

export default node;
